import { css } from 'lit';

export const nsFlyoutStyles = css`
  :host {
    position: fixed;
    z-index: 999;
    box-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--ns-theme-black) 20%, transparent);
    opacity: 0;
    transform: var(--ns-flyout-closed-transform, scale(0));
    transform-origin: var(--ns-flyout-origin, 0% 100%);
    pointer-events: none;
    transition:
      opacity 0.2s ease-out,
      transform 0.2s ease-out;
  }

  :host([open]) {
    opacity: 1;
    transform: var(--ns-flyout-open-transform, scale(1));
    pointer-events: auto;
  }
`;
